<section class="cz-survey-report-dialog-component">
  <mat-dialog-title class="mat-dialog-title">
    <div class="row">
      <div class="col-xs-7">
        <h3 class="title" [innerHTML]="'$survey_report_dialog_heading' | translate"></h3>
      </div>
      <div class="col-xs-5 end-xs">
        <button mat-button mat-dialog-close class="mat-dialog-back-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-title>
  <mat-dialog-content>
    <div class="waiting">
      <h5 [innerHTML]="'$common_pdf_generated_message' | translate"></h5>
      <mat-spinner diameter="50" class="spinner" color="accent"></mat-spinner>
    </div>
    <object [data]="pdfLink | safeResourceUrl" width="1000" height="100%" class="pdf-object"></object>
  </mat-dialog-content>
</section>